import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, switchMap, tap } from 'rxjs';
import {environment} from '../../../environments/environment';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent {
    private searchSubject = new Subject<string>();
    isGlobalSearch:boolean = false;
    isLoading:boolean = false;
    globalSearchResult:any = [];
    searchQuery:any = "";
    isFetched: boolean;
    admin:boolean = false;
    accountNgrx$;
    cancelReq:boolean = false;

    constructor(private http: HttpClient, public store: Store<any>,) { }
  
    ngOnInit() {
      this.accountNgrx$ = this.store.select<any>((state) => state.profile?.account);
      this.accountNgrx$.subscribe(message => {
        console.log("accountNgrx$", message)
        if(message?.primary_role == 'owner') {
          this.admin = true;
        }
      })
      this.searchSubject.pipe(
        debounceTime(500),  // Wait for 500ms after the last keystroke
        distinctUntilChanged(),  // Only trigger if the query actually changes
        switchMap((query) => this.getSearchData(query))
      ).subscribe();
    }

    onSearch(query: string, cancelReq:boolean = false) {
      console.log(query)
      if(cancelReq ) {
        this.cancelReq = true;
        this.searchQuery = '';
        this.globalSearchResult = [];
        this.ngOnInit();
      }
      if(query.length > 2) {
        this.searchSubject.next(query);
        this.cancelReq = false;
      } else {
        this.globalSearchResult = [];
      }
    }

  // async searchRosterMember(e=null){
  //     console.log(e, e.target.value)
  //     if(this.searchQuery.length > 2){
  //       this.isGlobalSearch = true;
  //       this.isLoading = true;
  //       let data = {}
  //       await this.http.post(`${environment.profileURL}/api/v1/roster_organizations/search_members?first_name=${this.searchQuery}`, data).subscribe((res:any)=> {
  //         this.isLoading = false
  //         this.organizations=res.members;
  //         console.log("res",res)
  //       })
  //     }
  //     // if(this.searchQuery.length > 0){
  //     //   this.isGlobalSearch = false;
  //     //   this.getDataFn();
  //     // }
  //   }

  getSearchData(value) {
      this.isLoading = true;
      this.isFetched = false;
      this.isGlobalSearch = true;
      let data = {}
      console.log("value", value)
      if(value.length) {
        const url:any = `${environment.profileURL}/api/v1/roster_organizations/search_members?search=${this.searchQuery}`
        return this.http.post<any>(url, data).pipe(
          tap(response => {
            response.members.forEach((item, index) => {
              let rosterArr= [];
              let rosterArrObj = [];
              item.teams.forEach((team, index) => {
                if(!rosterArr.includes(team.organization_id)) {
                  rosterArr.push(team.organization_id)
                  rosterArrObj.push({roster_id: team?.organization_id, roster_name: team?.organization_name})
                }
              })
              item.roster_details = rosterArrObj;
            })
            console.log(response.members)
            if(!this.cancelReq) {
              this.globalSearchResult = response.members;
            }
            this.isLoading = false;
            this.isFetched = true;
          })
        );
      }
  }

  truncateString(str: string, maxLength: number): string {
      if (!str) return ""
      return str.length > maxLength ? str.slice(0, maxLength) + "…" : str
  }

  goToProfile(profile) {
    localStorage.setItem('fs-profile-gs', JSON.stringify(profile))
  }

  gotoRoster() {
    localStorage.setItem('fs-roster-gs', JSON.stringify(true))
  }

  org(value) {
    localStorage.setItem("currentOrgName", value);
  }
}
